import React from 'react'
import { ekincare_full_logo} from '../../assets/images'
import {LeftPanel} from '../common/templates/Login';
import MFAConfirmation from '../common/templates/Login/MFAConfirmation';
import { useHistory } from 'react-router-dom';

function MFAConfirmationPage() {
  const history = useHistory()
  
  const continueMFA =  () => {
    history.push('/mfa-method')
  }
  return (
    <div className='flex min-h-screen'>
        <LeftPanel />
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={ekincare_full_logo} alt='ekincare_logo' />
        <MFAConfirmation continueMFA={continueMFA} />
      </div> 
    </div>  
  )
}

export default MFAConfirmationPage

